import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { hasSession } from '../_helpers/session';

export const PrivateRoute = ({ children }) => {
  const location = useLocation();

  if (!hasSession()) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
};
